import { render, staticRenderFns } from "./projectsSubcontracts.vue?vue&type=template&id=65f9fe9c&scoped=true"
import script from "./projectsSubcontracts.vue?vue&type=script&lang=js"
export * from "./projectsSubcontracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f9fe9c",
  null
  
)

export default component.exports